<template>
	<div>
		<myheader headTitle="添加企业成员"></myheader>
		<div class="all_main">
			<div class="all_content_padding">
				<div class="all_tips_content_card">
					<div class="text14 textcolor666 margin_top_10">请填写用户信息</div>
					<div class="all_tips_red_after text14 textcolor666 margin_top_10">用户姓名</div>
					<div class="all_tips_input" :class="{ isfocus: nameFocus }">
						<van-field class="my_input textcolor333" placeholder="请输入用户姓名" v-model="memberName"
							@focus="getFocus(1)" @blur="onblur(1)" clearable />
					</div>
					<div class="all_tips_red_after text14 textcolor666 margin_top_10">用户账号</div>
					<div class="all_tips_input" :class="{ isfocus: accountFocus }">
						<van-field class="my_input text14 textcolor333" placeholder="请输入用户账号" v-model="memberAccount"
							@focus="getFocus(2)" @blur="onblur(2)" clearable />
					</div>
					<div class="all_tips_red_after text14 textcolor666 margin_top_10">签约单位</div>
					<div class="all_tips_input">
						<van-field class="my_input textcolor333" v-model="corpName" readonly clearable />
					</div>
					<div class="all_tips_red_after text14 textcolor666 margin_top_10">用户权限</div>
					<div class="all_tips_input" @click="showBottom = true">
						<van-field class="my_input text14 textcolor333" v-model="memberPermission" readonly clearable />
					</div>
				</div>
				<!-- <div class="all_tips_bottom_card">
					<button class="all_button24 width_100 text16 bmain_active" @click="sumbit()">发&nbsp;&nbsp;送</button>
				</div> -->
			</div>
		</div>
		<van-popup v-model:show="showBottom" :overlay="true" position="bottom">
			<div>
				<div style="margin: .5rem .8rem;" class="text16 textcolor333">设置用户权限</div>
				<div class="horizontal_line"></div>
				<div style="margin: 1rem .8rem;"><van-checkbox class="text14 textcolor333"
						v-model="isSigner">签名人</van-checkbox></div>
				<div class="horizontal_line"></div>
				<div style="margin: 1rem .8rem;"><van-checkbox class="text14 textcolor333"
						v-model="isSealer">盖章人</van-checkbox></div>
				<div class="horizontal_line"></div>
				<div>
					<button style="width: 40%;margin: 5%;" class="all_button20 text16 backgroundC_ccc bwhite_ative"
						@click="showBottom = false">取消</button>
					<button style="width: 40%;margin: 5%;" class="all_button20 text16 bmain_active"
						@click="sumbit()">确定</button>
				</div>
			</div>
		</van-popup>
	</div>
</template>

<script>
	import Vue from "vue";
	import {
		Field,
		Checkbox,
	} from "vant";
	export default {
		components: {
			[Field.name]: Field,
			[Checkbox.name]: Checkbox,
		},
		data() {
			return {
				//
				showBottom: false,
				//企业id
				corpId: '',
				//
				corpName: '',
				//成员姓名
				memberName: '',
				nameFocus: false,
				//成员账号
				memberAccount: '',
				accountFocus: false,
				//成员权限
				memberPermission: '',
				//
				isSealer: false,
				//
				isSigner: false
			}
		},
		methods: {
			//发送邀请
			sumbit() {
				this.memberName = this.memberName.trim()
				this.memberAccount = this.memberAccount.trim()
				if (!this.memberName) {
					this.$Toast('请输入姓名！')
					return
				}
				if (!this.memberAccount) {
					this.$Toast('请输入账户！')
					return
				}
				if (!this.isSealer && !this.isSigner) {
					this.$Toast('请选择用户权限！')
					return
				}
				this.$store.dispatch(this.$LoadShow, true)
				this.$post('/corp/m/api/inviteJoinCorp?corpId=' + this.corpId, {
					isSealer: this.isSealer,
					isSigner: this.isSigner,
					staffName: this.memberName,
					userName: this.memberAccount
				}).then((res) => {
					this.$store.dispatch(this.$LoadShow, false)
					if (res.success) {
						this.$Toast('添加成功！')
						this.$router.go(-1)
					} else {
						this.$Toast(res.message || res.messageDetail || '添加失败！')
					}
				}).catch(err => {
					this.$store.dispatch(this.$LoadShow, false)
					this.$Toast('添加失败！')
					console.log('inviteJoinCorp',err)
				})
			},
			//获取焦点
			getFocus(flag) {
				if (flag === 1) {
					this.nameFocus = true
				} else if (flag === 2) {
					this.accountFocus = true
				}
			},
			//失去焦点
			onblur(flag) {
				if (flag === 1) {
					this.nameFocus = false
				} else if (flag === 2) {
					this.accountFocus = false
				}
			},
			//初始化
			init() {
				this.corpId = this.$route.query.corpId
				this.corpName = this.$route.query.corpName
			},
		},
		mounted() {
			this.init()
		}
	}
</script>

<style scoped lang="scss">
	@import "../../../styles/global.css";

	::v-deep .van-cell {
		padding: 10px .3rem;
	}
</style>